import React, { useState } from "react";
import Layout from "../components/Layout";

const ApplicationManagement = () => {
    const [applications, setApplications] = useState([
        { id: 1, name: "Application 1", status: "Pending" },
        { id: 2, name: "Application 2", status: "Approved" },
        { id: 3, name: "Application 3", status: "Rejected" },
        // Добавьте больше заявок по необходимости
    ]);
    const [sortOrder, setSortOrder] = useState("asc");

    const handleSort = (field) => {
        const sortedApplications = [...applications].sort((a, b) => {
            if (a[field] < b[field]) return sortOrder === "asc" ? -1 : 1;
            if (a[field] > b[field]) return sortOrder === "asc" ? 1 : -1;
            return 0;
        });
        setApplications(sortedApplications);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleStatusChange = (id, status) => {
        setApplications(applications.map(app => app.id === id ? { ...app, status } : app));
    };

    return (
        <Layout>
            <div className="container">
                <div className="application-management">
                    <h1>Управление заявками</h1>
                    <table className="application-management__table">
                        <thead>
                            <tr>
                                <th onClick={() => handleSort("name")}>Название</th>
                                <th onClick={() => handleSort("status")}>Статус</th>
                                <th>Управление</th>
                            </tr>
                        </thead>
                        <tbody>
                            {applications.map(application => (
                                <tr key={application.id}>
                                    <td>{application.name}</td>
                                    <td>{application.status}</td>
                                    <td>
                                        <button onClick={() => handleStatusChange(application.id, "Approved")}>Разрешить</button>
                                        <button onClick={() => handleStatusChange(application.id, "Rejected")}>Отклонить</button>
                                        <button onClick={() => handleStatusChange(application.id, "Suspended")}>Приостановить</button>
                                        <button onClick={() => handleStatusChange(application.id, "Deferred")}>Отложить</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
};

export default ApplicationManagement;